import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import { CoreRequestProvider } from "./providers/RequestProvider";
import { LanguageProvider } from "./providers/LanguageProvider";
import { ThemeProvider } from "./providers/ThemeProvider";
import { UserProvider } from "./providers/UserProvider";
import { CurrencyProvider } from "./providers/CurrencyProvider";

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <CookiesProvider>
        <LanguageProvider>
          <ThemeProvider>
            <UserProvider>
              <CoreRequestProvider>
                <CurrencyProvider>
                  <App />
                </CurrencyProvider>
              </CoreRequestProvider>
            </UserProvider>
          </ThemeProvider>
        </LanguageProvider>
      </CookiesProvider>
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById("root")
);
reportWebVitals();
